import React, { useEffect, useState } from "react";
import PromiseCard from "components/card/PromiseCard";
import { getPredictors } from "api-algolia/predictors.api";
import { createPromise } from "api/promises.api"; // reuse createPrediction

const PromiseModal = ({ data, isOpen, onClose }) => {
  const [cardItem, setCardItem] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !data) return;

    const fetchPredictor = async () => {
      const authorName = data.authorName || data.analysis?.authorName || "";
      const [firstName, ...lastNameParts] = authorName.split(" ");
      const lastName = lastNameParts.join(" ");

      try {
        const result = await getPredictors({
          searchText: authorName,
          length: 1,
        });

        const predictorData =
          result.hits && result.hits.length > 0 ? result.hits[0] : null;

        const mappedItem = {
          title: data.analysis?.promiseTitle || data.promiseTitle || data.title,
          description:
            data.analysis?.publishSummary ||
            data.publishSummary ||
            data.publishArticle ||
            data.promise,
          predictor: predictorData
            ? { ...predictorData }
            : { firstName, lastName, image: data.authorImage || null },
          image: data.image || null,
          endOfVoting: null,
          deadline: null,
          type: "new",
          result: null,
        };

        setCardItem(mappedItem);
      } catch (err) {
        console.error("Error fetching predictor:", err);
      }
    };

    fetchPredictor();
  }, [isOpen, data]);

  const handleCreatePromise = async () => {
    if (!cardItem) return;

    setLoading(true);

    try {
      const newDoc = await createPromise({
        title: cardItem.title,
        description: cardItem.description,
        predictor: cardItem.predictor,
        image: cardItem.image,
        createdAt: Date.now(),
        type: "promise", // mark it as promise
      });

      if (newDoc?.id) {
        // Redirect to manage page for promises
        window.location.href = `/promises/manage/${newDoc.id}`;
      } else {
        console.error("Failed to create promise");
      }
    } catch (err) {
      console.error("Error creating promise:", err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !cardItem) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-[600px] max-w-full relative">
        <button
          className="absolute top-4 right-4 text-gray-600 font-bold"
          onClick={onClose}
        >
          X
        </button>

        <PromiseCard
          showTimers
          hidePrimaryButton
          item={cardItem}
          isSelected={false}
          onCardClick={() => {}}
          isDisabled={true}
        />

        {/* Create Promise Button */}
        <div className="mt-4 text-center">
          <button
            onClick={handleCreatePromise}
            disabled={loading}
            className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 disabled:opacity-50"
          >
            {loading ? "Ստեղծվում է..." : "Ստեղծել խոստում"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromiseModal;
